export const siteURL = 'https://api.betakomerc.rs';
export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/v1/`;
